<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav />

      <div class="layout-container">
        <app-layout-navbar />

        <div class="layout-content">
          <div v-if="$store.state.user.trial_days_remaining !== null" class="label-env-container small" @click="$router.push('/billing')">
            <div class="badge badge-danger label-env">Your free trial has {{ $store.state.user.trial_days_remaining }} days remaining! Click here to buy now.</div>
          </div>
          <div class="router-transitions container-fluid flex-grow-1 container-p-y">
            <router-view :key="$route.fullPath" />
          </div>

          <app-layout-footer />
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar'
import LayoutSidenav from './LayoutSidenav'
import LayoutFooter from './LayoutFooter'

export default {
  name: 'app-layout-2',
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    'app-layout-footer': LayoutFooter
  },

  mounted () {
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
  },

  beforeDestroy () {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav () {
      this.layoutHelpers.setCollapsed(true)
    }
  }
}
</script>

<style scoped>
  .label-env-container {
      position: absolute;
      left: 50%;
      width: 100%;
      transform: translate(-50%);
      z-index: 100;
      cursor: pointer;
  }

  .label-env {
      z-index: 1500;
      font-size: 12pt;
      margin: auto;
      display: table;
  }
</style>